import { Component } from "react";

/**
 * App-wide error boundary. Catches render-time crashes in any page/component
 * so a single bad component can never blank the entire app — instead we show a
 * recoverable fallback. Without this, an uncaught render error unmounts the
 * whole React tree and the user sees a white screen.
 */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary caught:", error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="min-h-screen bg-[#0A0A0B] text-[#F4F4F5] flex items-center justify-center px-6"
        data-testid="error-boundary-fallback">
        <div className="max-w-md text-center">
          <div className="text-[40px] mb-3">😵‍💫</div>
          <h1 className="text-[20px] font-semibold mb-2">Something went wrong</h1>
          <p className="text-[14px] text-[#B0AEBC] mb-7 leading-relaxed">
            This page hit an unexpected error. Your data is safe — try reloading,
            or head back to your dashboard.
          </p>
          <div className="flex items-center justify-center gap-3">
            <button
              onClick={() => window.location.reload()}
              data-testid="error-reload-btn"
              className="btn btn-primary px-5 py-2.5"
            >
              Reload
            </button>
            <button
              onClick={() => { window.location.href = "/app"; }}
              data-testid="error-home-btn"
              className="btn btn-secondary px-5 py-2.5"
            >
              Go to dashboard
            </button>
          </div>
        </div>
      </div>
    );
  }
}
